module.exports = __webpack_public_path__ + "static/img/24_pro.2c72c9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/24_pro.jpg
// module id = f5bB
// module chunks = 0